import { useCallback, useEffect, useRef, useState } from 'react';

export const useDebounce = (delay, callback) => {
    const [args, setArgs] = useState();
    const [count, setCount] = useState(0);
    const timerRef = useRef();
    const instantFiredRef = useRef(false);

    useEffect(() => {
        if (count === 0) {
            return;
        }

        if (instantFiredRef.current) {
            instantFiredRef.current = false;
            return;
        }

        const timeout = timerRef.current = setTimeout(callback, delay, ...args);

        return () => {
            clearTimeout(timeout);
            timerRef.current = null;
        };
    }, [args, callback, delay, count]);

    return useCallback((...args) => {
        setArgs(args);
        setCount(current => current + 1);

        return {
            fire: () => {
                clearTimeout(timerRef.current);
                timerRef.current = null;

                callback(...args);
            },
        };
    }, [callback]);
};
